import axios from "axios";

export async function onCloseDay(allLuckets, currentDate, closeOption) {
  if (currentDate === new Date().toLocaleDateString()) {
    alert("Cannot close day, wait till the day is over.");
    return;
  }

  try {
    const server_hostname = ((process.env.REACT_APP_IS_ALL_LOCAL == "true") ? process.env.REACT_APP_LOCAL_SERVER_HOST : process.env.REACT_APP_PROD_SERVER_HOST) + "/sheets/close-day"


    // Use axios for the API call
    const response = await axios.post(
      server_hostname,
      {
        allLuckets,
        currentDate,
        closeOption,
      },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
          'Content-Type': 'application/json'
        }
      }
    );


    const result = await response.data;
    if (response.status === 200) {
      console.log(result.message);
    } else {
      console.error('Error:', result.message);
    }
    return result
  } catch (error) {
    console.error('Network error while closing the day:', error);
  }
}
